import axios from 'axios';
import url from '@/url';

const authHeaders = () => ({
  'X-Authorization': localStorage.getItem('token'),
});

const baseUrl = () => `${process.env.VUE_APP_SERVICE_URL}${url.admin_public_circles}`;

const unwrap = (response, fallback = null) => {
  if (response?.data?.result?.status === 200) {
    return response.data.result.data ?? fallback;
  }
  return fallback;
};

export const getPublicCircles = async () => {
  const response = await axios.get(baseUrl(), { headers: authHeaders() });
  return unwrap(response, []);
};

export const createPublicCircle = async (payload) => {
  const response = await axios.post(baseUrl(), payload, { headers: authHeaders() });
  return unwrap(response, null);
};

export const updatePublicCircle = async (circleId, payload) => {
  const response = await axios.put(`${baseUrl()}/${circleId}`, payload, { headers: authHeaders() });
  return unwrap(response, null);
};

export const getPublicCircleStudents = async (circleId) => {
  const response = await axios.get(`${baseUrl()}/${circleId}/students`, { headers: authHeaders() });
  return unwrap(response, { circle: null, students: [] });
};

export const registerStudentsToPublicCircle = async (circleId, studentIds, replaceAll = false) => {
  const response = await axios.post(
    `${baseUrl()}/${circleId}/students`,
    { studentIds, replaceAll },
    { headers: authHeaders() },
  );
  return unwrap(response, null);
};

export const removeStudentFromPublicCircle = async (circleId, studentId) => {
  const response = await axios.delete(`${baseUrl()}/${circleId}/students/${studentId}`, {
    headers: authHeaders(),
  });
  return unwrap(response, null);
};

export const updatePublicCircleStudentStatus = async (circleId, studentId, status) => {
  const response = await axios.patch(
    `${baseUrl()}/${circleId}/students/${studentId}/status`,
    { status },
    { headers: authHeaders() },
  );
  return unwrap(response, null);
};

export const moveStudentBetweenPublicCircles = async ({ studentId, fromCircleId, toCircleId }) => {
  const response = await axios.post(
    `${process.env.VUE_APP_SERVICE_URL}${url.admin_public_circles_move_student}`,
    { studentId, fromCircleId, toCircleId },
    { headers: authHeaders() },
  );
  return unwrap(response, null);
};

export const getPublicCircleAttendanceLogs = async ({ circleId, date } = {}) => {
  const params = {};
  if (circleId) params.circleId = Number(circleId);
  if (date) params.date = date;
  const response = await axios.get(`${baseUrl()}/attendance-logs`, {
    headers: authHeaders(),
    params,
  });
  return unwrap(response, { date: null, items: [] });
};

export const getPublicCircleDailyChatLogs = async ({ circleId, date } = {}) => {
  const params = {};
  if (circleId) params.circleId = Number(circleId);
  if (date) params.date = date;
  const response = await axios.get(`${baseUrl()}/daily-chat-logs`, {
    headers: authHeaders(),
    params,
  });
  return unwrap(response, { date: null, items: [] });
};

export const getPublicCircleDailyChatDates = async ({ circleId } = {}) => {
  const params = {};
  if (circleId) params.circleId = Number(circleId);
  const response = await axios.get(`${baseUrl()}/daily-chat-dates`, {
    headers: authHeaders(),
    params,
  });
  return unwrap(response, []);
};

export const deletePublicCircleDailyChatMessage = async (messageId) => {
  const response = await axios.delete(`${baseUrl()}/daily-chat-logs/${messageId}`, {
    headers: authHeaders(),
  });
  return unwrap(response, null);
};

